(() => {
  const init = () => {
    document.querySelectorAll('[data-ss-sticky-cart]').forEach((bar) => {
      if (bar.dataset.ssStickyReady === 'true') return;
      bar.dataset.ssStickyReady = 'true';

      const sectionId = bar.dataset.sectionId;
      const trigger = bar.querySelector('[data-ss-sticky-add]');
      const productInfo = document.querySelector(`#MainProduct-${sectionId}`);
      const productForm = document.querySelector(`#product-form-${sectionId}`);
      const normalButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

      if (!trigger || !productInfo) return;

      const setVisible = () => {
        const show = window.scrollY > 420;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        document.documentElement.classList.toggle('ss-sticky-cart-active', show);
      };

      window.addEventListener('scroll', setVisible, { passive: true });
      setVisible();

      trigger.addEventListener('click', () => {
        const personaliserButton = productInfo.querySelector('[data-ss-add-to-cart]');

        if (personaliserButton) {
          personaliserButton.click();
          window.setTimeout(() => {
            const active = document.activeElement;
            if (active && productInfo.contains(active)) {
              active.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 80);
          return;
        }

        if (normalButton) {
          normalButton.click();
        } else if (productForm) {
          productForm.requestSubmit();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
